import { keyframes } from 'glamor'

import { UiTheme } from '../../theme'
import { rgba } from '../../utils/colors'

const shimmer = keyframes({
  from: {
    transform: 'translate3d(-500px, 0, 0)',
  },
  to: {
    transform: 'translate3d(1000px, 0, 0)',
  },
})

export default (theme: UiTheme) => ({
  placeholder: {
    base: {
      display: 'inline-block',
      height: '1.2em',
      position: 'relative',
      overflow: 'hidden',
      maxWidth: '100%',
      verticalAlign: 'middle',
    },

    variants: {
      alert: {
        backgroundColor: rgba(theme.colors.baseColors.warning, 0.05),
      },
      negative: {
        backgroundColor: rgba(theme.colors.baseColors.danger, 0.05),
      },
      positive: {
        backgroundColor: rgba(theme.colors.baseColors.cta, 0.05),
      },
      link: {
        backgroundColor: rgba(theme.colors.baseColors.primaryAccent, 0.05),
      },
      dim: {
        backgroundColor: rgba(theme.colors.baseColors.dark, 0.0375),
      },
      normal: {
        backgroundColor: rgba(theme.colors.baseColors.dark, 0.0375),
      },
      white: {
        backgroundColor: rgba(theme.colors.baseColors.white, 0.25),
      },
    },
  },

  shimmer: {
    base: {
      width: '500px',
      height: '100%',
      position: 'absolute',
      backgroundSize: '500px 100%',
      backgroundRepeat: 'no-repeat',
      backgroundImage:
        'linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 100%)',

      animation: 'shimmer 2s linear infinite',
      animationName: shimmer,
    },

    variants: {
      white: {
        backgroundImage:
          'linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.125) 50%, rgba(255,255,255,0) 100%)',
      },
    },
  },
})
